// "My Market" modal (header Search User pick) — the `analysis` object it renders.
//
// Contract (what components/MyMarketModal reads):
//   gameDetail : { username, fullname, accountType, general, exposure, creditReference }
//   userLock   : [{ masterName, userActive: bool, betActive: bool }]
//   gameLock   : [{ masterName, betLock: bool, eventName }]   // [] → "No records found"
//
// Today it is built from the search row (GET /admin/search-by-username):
//   · gameDetail — the row's own balances (backend: wallet + net exposure)
//   · userLock   — the row's DIRECT parent only, `row.parent`
//                  { username, active, bet_locked } (backend, merge e7ec975f).
//                  The reference lists the whole upline chain; that needs
//                  `report/searchanalysis` — see docs/handover/2026-09-19-search-analysis-api.md
//   · gameLock   — no per-event lock data yet → []
// When that endpoint exists, Layout passes its response as `analysis` and the
// modal needs no change.

export const buildSearchAnalysis = (row) => ({
  gameDetail: {
    username: row?.username || '',
    fullname: row?.fullname || row?.full_name || '',
    accountType: row?.user_type || row?.role || '',
    general: Number(row?.available_points ?? row?.inr_balance ?? row?.cash) || 0,
    exposure: Math.abs(Number(row?.total_exposure ?? row?.exposure) || 0),
    creditReference: Number(row?.credit ?? row?.credit_ref) || 0,
  },
  // whole upline chain, direct parent first (search API `uplines`; falls
  // back to the single `parent` an older server sends)
  userLock: (row?.uplines || (row?.parent?.username ? [row.parent] : [])).map((u) => ({
    masterName: u.username,
    userActive: u.active !== false,
    betActive: !u.bet_locked,
  })),
  // search API `game_locks`: the account's sport-level General Locks,
  // shown as "<direct parent> | ✓ | <sport>" like the reference
  gameLock: (row?.game_locks || []).map((g) => ({
    masterName: g.master_name,
    betLock: !!g.bet_lock,
    eventName: g.event_name,
  })),
})
